export const director = {
  name: "김명헌",
  role: "명불허전 수학학원 원장",
  intro: "서울대학교 수학교육과 졸업 · 수학 교육 18년",
  image:
    "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20photograph%20of%20a%20confident%20Korean%20male%20academy%20director%20in%20his%20late%2040s%20wearing%20a%20smart%20dark%20navy%20blazer%20over%20a%20white%20shirt%2C%20warm%20friendly%20smile%2C%20standing%20in%20a%20bright%20modern%20classroom%20with%20soft%20blurred%20bookshelves%20and%20a%20green%20chalkboard%20behind%20him%2C%20soft%20natural%20window%20light%2C%20warm%20neutral%20tones%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=900&height=1100&seq=mbhj-about-director-01&orientation=portrait",
  message: [
    "안녕하세요, 명불허전 수학학원 원장 김명헌입니다. 저희 학원의 이름처럼, 수학은 '이름값'을 해야 한다고 믿습니다. 화려한 말보다 성적으로 증명하는 수학을 지향합니다.",
    "18년 동안 수학 한 길만 걸으며 깨달은 것은, 학생 한 명 한 명의 상황이 모두 다르다는 점입니다. 그래서 저희는 입학테스트로 현재를 정확히 진단하고, 소수정예 1:6 수업으로 학생 개개인의 질문이 끝까지 보장되는 환경을 만들었습니다.",
    "성적은 단순히 문제를 많이 푼다고 오르지 않습니다. 개념을 제대로 세우고, 틀린 문제의 원인을 찾고, 다시 풀어보는 과정이 쌓여야 비로소 오릅니다. 저희는 그 과정을 매주, 매달 꼼꼼하게 챙깁니다.",
    "아이의 수학을 고민하고 계신 학부모님이라면, 부담 없이 상담부터 신청해 주세요. 가장 적합한 길을 함께 찾아드리겠습니다.",
  ],
  highlights: [
    { value: "18년", label: "수학 교육 경력" },
    { value: "1,200+", label: "지도한 학생 수" },
    { value: "98%", label: "재등록률" },
  ],
};

export const teachers = [
  {
    name: "이수진",
    role: "부원장 · 중등부 대표",
    specialty: "중등 내신 전문",
    career: "12년",
    desc: "학교별 내신 출제 경향 분석과 등급 상승 관리가 강점입니다.",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20photograph%20of%20a%20friendly%20Korean%20female%20mathematics%20teacher%20in%20her%20mid%2030s%20wearing%20a%20neat%20beige%20blazer%2C%20gentle%20warm%20smile%2C%20standing%20in%20a%20bright%20modern%20classroom%20with%20a%20softly%20blurred%20whiteboard%20and%20bookshelves%20behind%20her%2C%20soft%20natural%20window%20light%2C%20warm%20neutral%20tones%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=1000&seq=mbhj-about-teacher-01&orientation=portrait",
  },
  {
    name: "박준호",
    role: "고등부 수Ⅰ·수Ⅱ 담당",
    specialty: "개념 완성 전문",
    career: "9년",
    desc: "어려운 개념을 쉽고 정확하게 전달하는 것으로 정평이 나 있습니다.",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20photograph%20of%20a%20Korean%20male%20mathematics%20teacher%20in%20his%20early%2030s%20wearing%20a%20smart%20grey%20knit%20sweater%2C%20approachable%20warm%20smile%2C%20standing%20in%20a%20bright%20modern%20classroom%20with%20softly%20blurred%20desks%20and%20a%20chalkboard%20behind%20him%2C%20soft%20natural%20window%20light%2C%20warm%20neutral%20tones%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=1000&seq=mbhj-about-teacher-02&orientation=portrait",
  },
  {
    name: "최민아",
    role: "초등부 담당",
    specialty: "연산 · 사고력 전문",
    career: "7년",
    desc: "아이가 수학을 즐겁게 느끼도록 기초 체력을 탄탄히 다져줍니다.",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20photograph%20of%20a%20cheerful%20Korean%20female%20elementary%20math%20teacher%20in%20her%20late%2020s%20wearing%20a%20soft%20cream%20cardigan%2C%20bright%20warm%20smile%2C%20standing%20in%20a%20bright%20modern%20classroom%20with%20colorful%20learning%20materials%20softly%20blurred%20behind%20her%2C%20soft%20natural%20window%20light%2C%20warm%20neutral%20tones%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=1000&seq=mbhj-about-teacher-03&orientation=portrait",
  },
  {
    name: "정하늘",
    role: "고등부 미적분 · 수능 담당",
    specialty: "수능 기출 전문",
    career: "11년",
    desc: "수능 기출 분석과 모의고사 성취 분석으로 목표 등급을 책임집니다.",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20photograph%20of%20a%20focused%20Korean%20male%20mathematics%20teacher%20in%20his%20mid%2030s%20wearing%20a%20smart%20charcoal%20blazer%2C%20confident%20subtle%20smile%2C%20standing%20in%20a%20bright%20modern%20classroom%20with%20a%20softly%20blurred%20green%20chalkboard%20and%20bookshelf%20behind%20him%2C%20soft%20natural%20window%20light%2C%20warm%20neutral%20tones%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=1000&seq=mbhj-about-teacher-04&orientation=portrait",
  },
];